function promisify(func) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return new Promise(function (resolve) {
      func.apply(undefined, [].concat(args, [resolve]));
    });
  };
}

export default promisify;